import { DashboardFeatureId } from '../../../../../AdviserArea/AdviserArea.types';

export const financialPlanSubFeatures = [
  DashboardFeatureId.WhatIfs,
  DashboardFeatureId.EditProfile,
];

export const currentFinancesSubFeatures = [
  DashboardFeatureId.Performance,
  DashboardFeatureId.Transactions,
  DashboardFeatureId.NetWorth,
];

export const beFiPlanSubFeatures = [
  DashboardFeatureId.AssetBucketing,
  DashboardFeatureId.BeFi20,
  DashboardFeatureId.Rtq,
  DashboardFeatureId.PulseCheck,
];
